import PropTypes from 'prop-types';
import React from 'react';


function FormError ({ id, className, message, 'data-test-id': testId }) {
    return (
        <p id={id} data-test-id={testId} className={ 'alert alert-danger ' + className }>
            { message }
        </p>
    );
}


FormError.propTypes = {
    id: PropTypes.string,
    message: PropTypes.string.isRequired,
    className: PropTypes.string,
    'data-test-id': PropTypes.string
};

FormError.defaultProps = {
    className: ''
};


export default FormError;
